import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

const GuestRoute = ({ children, redirectTo = '/admin' }) => {
  const { isAuthenticated, isLoading } = useSelector(state => state.auth)
  const location = useLocation()
  
  // Показываем загрузку пока проверяем аутентификацию
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    )
  }
  
  // Если уже аутентифицирован, перенаправляем в админку
  if (isAuthenticated) {
    // Используем состояние из location или дефолтный путь
    const from = location.state?.from?.pathname || redirectTo
    return <Navigate to={from} replace />
  }
  
  return children
}

export default GuestRoute